import {
	SET_FAAS, 
	GET_FAAS,
	RESET_FAAS
} from '../constants/Faas';

export const setFaas = (faas) => {
	let data = {
		type: SET_FAAS,
		payload: faas
	}
	return data
};

export const getFaas = () => {
	return {
		type: GET_FAAS
	}
};

export const resetFaas = () => {
	return {
		type: RESET_FAAS
	}
};
